module.exports = __webpack_public_path__ + "img/cast_ic_readiness.ad0c2a50.svg";